import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=3c6ce6fe&scoped=true&"
import script from "./pagination.js?vue&type=script&lang=js&"
export * from "./pagination.js?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=3c6ce6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6ce6fe",
  null
  
)

export default component.exports